"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findVaultAddress = exports.findPoolAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../../constants");
/**
 * Finds the address of the Pool.
 * @returns
 */
const findPoolAddress = ({ programId = constants_1.SUNNY_ADDRESSES.SunnySaberFarm, rewardsMint = constants_1.SBR_ADDRESS, landlord, creator, lpMint, }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("SunnySaberPool"),
        landlord.toBuffer(),
        rewardsMint.toBuffer(),
        creator.toBuffer(),
        lpMint.toBuffer(),
    ], programId);
});
exports.findPoolAddress = findPoolAddress;
/**
 * Finds the address of the Vault.
 * @returns
 */
const findVaultAddress = ({ programId = constants_1.SUNNY_ADDRESSES.SunnySaberFarm, pool, owner, }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("SunnySaberVault"),
        pool.toBuffer(),
        owner.toBuffer(),
    ], programId);
});
exports.findVaultAddress = findVaultAddress;
//# sourceMappingURL=pda.js.map